import {
    useDownloadLatestToken2UploadReport,
    useDownloadLatestUsersUploadReport,
    useDownloadToken2TemplateCsv,
    useDownloadUsersCsv,
    useUploadCsvFile
} from '../../../api';
import { useCallback } from 'react';
import { showAlert } from '@silverfort/sf-components';
import { useGetLatestUploadReport } from '../../../api/queries/useGetLatestUploadReport';

const useUserTableToolbarActions = (filters) => {
    const { latestUploadReport, fetchData } = useGetLatestUploadReport();

    const { downloadLatestUsersUploadReport, loading: isDownloadingLatestUserReport } =
        useDownloadLatestUsersUploadReport({
            onSuccess: useCallback(
                () => showAlert('Report was downloaded successfully', 'success', { title: 'Export successful' }),
                []
            ),
            onError: useCallback(() => showAlert('Failed to download file', 'error', { title: 'Export failed' }), [])
        });

    const { downloadLatestToken2UploadReport, loading: isDownloadingLatestToken2Report } =
        useDownloadLatestToken2UploadReport({
            onSuccess: useCallback(
                () => showAlert('Report was downloaded successfully', 'success', { title: 'Export successful' }),
                []
            ),
            onError: useCallback(() => showAlert('Failed to download file', 'error', { title: 'Export failed' }), [])
        });

    const { generateAndDownloadUsersFile, loading: isGenerateAndDownloadUsersFileLoading } = useDownloadUsersCsv({
        filters,
        onSuccess: useCallback(() => {
            showAlert('File was downloaded successfully', 'success', { title: 'Export successful' });
            fetchData();
        }, []),
        onError: useCallback(
            (error) => showAlert(error ?? 'Failed to download file', 'error', { title: 'Export failed' }),
            []
        )
    });

    const { generateAndDownloadToken2TemplateFile } = useDownloadToken2TemplateCsv({
        onSuccess: useCallback(
            () => showAlert('File was downloaded successfully', 'success', { title: 'Export successful' }),
            []
        ),
        onError: useCallback(() => showAlert('Failed to download file', 'error', { title: 'Export failed' }), [])
    });

    const { uploadCsv } = useUploadCsvFile({
        onSuccess: useCallback(({ type }) => {
            showAlert('Updates will be reflected in the table', 'success', {
                title: `${type === 'user' ? 'Users' : 'Token2'} uploaded successfully`
            });
            fetchData();
        }, []),
        onError: useCallback(
            () =>
                showAlert(
                    'An error occurred while uploading your CSV. Check the file to ensure format and content are valid, and try again.',
                    'error',
                    { title: 'Failed to upload CSV' }
                ),
            []
        )
    });

    return {
        generateAndDownloadUsersFile,
        isGenerateAndDownloadUsersFileLoading,
        downloadLatestUsersUploadReport,
        isDownloadingLatestUserReport,
        downloadLatestToken2UploadReport,
        isDownloadingLatestToken2Report,
        uploadCsv,
        generateAndDownloadToken2TemplateFile,
        latestUploadReport
    };
};
export default useUserTableToolbarActions;
